import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./CertificationRegistrationLoader.css";

const messages = [
  "Started the Registration",
  "Just few seconds...",
  "Almost there...",
];

export default function CertificationRegistrationLoader({
  isOpen,
  imageSrc,
  loading,
  onClose,
}) {
  const [canClose, setCanClose] = useState(false);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    let messageTimer;
    let minTimeTimer;

    if (isOpen) {
      // Reset state when modal opens
      setCanClose(false);
      setMessageIndex(0);

      // Cycle through messages every 1.5 seconds
      messageTimer = setInterval(() => {
        setMessageIndex((idx) => (idx + 1) % messages.length);
      }, 1700);

      // Set minimum display time of 5 seconds
      minTimeTimer = setTimeout(() => {
        setCanClose(true);
      }, 5000);
    }

    return () => {
      clearInterval(messageTimer);
      clearTimeout(minTimeTimer);
    };
  }, [isOpen]);

  useEffect(() => {
    // Close modal when both conditions are met
    if (isOpen && canClose && !loading) {
      onClose?.();
    }
  }, [isOpen, canClose, loading, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="certificationRegistrationLoader-modal">
          <motion.div
            className="certificationRegistrationLoader-content"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src={imageSrc}
              alt="Certification Loader"
              className="certificationRegistrationLoader-image"
            />
            <AnimatePresence mode="wait">
              <motion.div
                key={messageIndex}
                className="certificationRegistrationLoader-message"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                {messages[messageIndex]}
              </motion.div>
            </AnimatePresence>
            <div className="certificationRegistrationLoader-spinner" />
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
